module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Augst-90bac741fd9cbca8136fff8da7a1254a.png";